module.exports = __webpack_public_path__ + "img/gm-mb.57c44c6f.png";